

import "./RoomPopUp.css";
import { useState } from "react";








export default function PopUpMenu  ({  onClose, onAddRoom }) {
    const [roomName, setRoomName] = useState("");
  
    const handleRoomNameChange = (e) => {
      setRoomName(e.target.value);
    };
  
    const handleAddRoom = () => {
      if (roomName) {
        onAddRoom(roomName);
        onClose();
      }
    };
    const closeMenu=()=>{
        const popUpToClose=document.getElementById("PopUp-Wrapper");
        console.log(popUpToClose+'ok')
        if(popUpToClose){
              popUpToClose.style.display="none"
              setRoomName('')
        }
    }
  
    return (
      <div 
      id="PopUp-Wrapper"  >
        <input
          type="text"
          placeholder="Room name"
          value={roomName}
          onChange={handleRoomNameChange}
          className="popUp-Input"
        />
        <div>
        <button onClick={handleAddRoom}>Add</button><button onClick={closeMenu}>x</button></div>
      </div>
    );
  };